"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStore = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _redux = require("redux");
var _reduxThunk = _interopRequireDefault(require("redux-thunk"));
var _reducers = require("./reducers");
// redux store is created here

// import { logger } from 'redux-logger';

// TODO add back logger to middleware below [ logger, thunk ]
// redux-logger doesnt build correctly in Babel 7
// occurred as part of upgrade to ui-zephyr / ui-boreas
// this logging function is development only, so was removed temporarily
var middleware = [_reduxThunk.default];
var getStore = function getStore() {
  var preloadedState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var siteInfoFn = arguments.length > 1 ? arguments[1] : undefined;
  var siteConfig = siteInfoFn();
  if (siteConfig.env === 'prod') {
    middleware = [_reduxThunk.default];
  }
  var store = (0, _redux.createStore)((0, _redux.combineReducers)({
    search: _reducers.searchReducer,
    table: _reducers.tableReducer,
    siteInfo: siteInfoFn
  }), preloadedState, _redux.applyMiddleware.apply(void 0, (0, _toConsumableArray2.default)(middleware)));
  return store;
};
exports.getStore = getStore;
